
const hbjx = 'https://janwin.top:81'//服务器
const hbjxym = 'http://janwin.top'//域名
//const hbjxym = 'http://localhost:8080/'//域名
//const hbjx = 'http://192.168.102.43:82'//杜鹏
//存储cookie
function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  // let d = new Date()
  // d.setTime(d.getTime() + ( 1 * 60 * 1000))
  // let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
//拿取cookie信息
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  // console.log("获取cookie,现在循环")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    // console.log(c)
    while (c.charAt(0) === " ") c = c.substring(1);
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
//格式化日期
function formatDate(date) {
  var date = new Date(date);
  var YY = date.getFullYear() + '';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return YY + '-' + MM + '-' + DD;
  // return YY + MM + DD +" "+hh + mm + ss;
}
//字符串加密
function encode(str){
  // 对字符串进行编码
  var encode = encodeURI(str);
  // 对编码的字符串转化base64
  var base64 = btoa(encode);
  return base64;
}
//字符串加密
function encodeNew(str){
  // 对字符串进行编码
  var encode = encodeURI(str);
  // 对编码的字符串转化base64
  var base64 = btoa(encode);
  if (base64.length>25) {
    base64 = base64.substring(0,25);
  }
  return base64;
}
//随机生成字符串
function generateCode() {
  let chars = '123456789';
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  let maxPos = chars.length;
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return code;
}
export default {
  hbjx,
  hbjxym,
  setCookie,
  getCookie,
  encode,
  generateCode,
  encodeNew
}





// WEBPACK FOOTER //
// ./src/api/global_variable.js